var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recommend_activity_table_pane" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-form" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchForm } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: "请输入活动名称",
                      clearable: "",
                      "prefix-icon": "el-icon-search",
                    },
                    model: {
                      value: _vm.searchForm.activityName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "activityName", $$v)
                      },
                      expression: "searchForm.activityName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "全部", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部", value: null },
                      }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "启用", value: 1 } }, [
                        _c("i", {
                          staticClass: "el-icon-circle-check",
                          staticStyle: { color: "#67C23A" },
                        }),
                        _vm._v(" 启用\n          "),
                      ]),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "禁用", value: 0 } }, [
                        _c("i", {
                          staticClass: "el-icon-circle-close",
                          staticStyle: { color: "#F56C6C" },
                        }),
                        _vm._v(" 禁用\n          "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.search },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("新增活动")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F7FA", color: "#606266" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "活动名称", "min-width": "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "activity-info" }, [
                      _c("div", { staticClass: "activity-name" }, [
                        _vm._v(_vm._s(scope.row.activityName)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "activity-meta" }, [
                        scope.row.storeScope === 0
                          ? _c("span", { staticClass: "store-badge" }, [
                              _c("i", { staticClass: "el-icon-shop" }),
                              _vm._v(" 全部门店\n            "),
                            ])
                          : _c("span", { staticClass: "store-badge" }, [
                              _c("i", {
                                staticClass: "el-icon-office-building",
                              }),
                              _vm._v(" 指定门店\n            "),
                            ]),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "scenesText",
              label: "适用场景",
              "min-width": "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.scenesText.split("、"),
                    function (scene, index) {
                      return _c(
                        "el-tag",
                        {
                          key: index,
                          attrs: {
                            size: "small",
                            type: _vm.getSceneTagType(scene),
                          },
                        },
                        [_vm._v("\n          " + _vm._s(scene) + "\n        ")]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商品数量", "min-width": "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.goodsCount || 0))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "执行时间", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "execution-time" }, [
                      scope.row.executionTime || scope.row.executionTimeRange
                        ? _c("div", { staticClass: "time-row" }, [
                            scope.row.executionTime
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "time-date",
                                    class: _vm.getTimeTypeClass(
                                      scope.row.timeType
                                    ),
                                  },
                                  [
                                    _c("i", {
                                      class: _vm.getTimeTypeIcon(
                                        scope.row.timeType
                                      ),
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.executionTime) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.executionTimeRange
                              ? _c("div", { staticClass: "time-range" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.executionTimeRange) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _c("span", { staticClass: "time-empty" }, [
                            _vm._v("-"),
                          ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", "min-width": "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-value": 1,
                        "inactive-value": 0,
                        "active-color": "#67C23A",
                        "inactive-color": "#DCDFE6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.status,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "status", $$v)
                        },
                        expression: "scope.row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDateTime(scope.row.createTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "160", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          删除\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
              background: true,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "header-title" }, [
        _c("i", { staticClass: "el-icon-s-order" }),
        _vm._v(" "),
        _c("span", [_vm._v("猜你喜欢活动列表")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }